import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../../assets/images/logo.png';
import { getCampaignFamilyConfig } from '../../../event-campaigns';
import { GeogroupAvatar } from '../../geogroup-avatar';
function Sponsors({
  defaultParticipationGroup,
  event
}) {
  const {
    t
  } = useTranslation();
  const sponsorName = defaultParticipationGroup?.title ?? event.sponsor ?? null;
  const showSponsorIcon = defaultParticipationGroup !== null && defaultParticipationGroup?.photo != null;
  // Some campaigns (eg. bfg) have no defaultParticipationGroup photo configured on the backend to
  // derive a second icon from, so fall back to their known co-organizer's logo rather than showing
  // the lone Geovelo icon.
  const coOrganizer = !showSponsorIcon ? getCampaignFamilyConfig(event.code)?.coOrganizer : undefined;
  if (!sponsorName && defaultParticipationGroup === null) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(_Box, {
    zIndex: 2
  }, /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: {
      title: 'Geovelo',
      photo: logo
    },
    size: 48,
    variant: "outlined"
  })), showSponsorIcon && defaultParticipationGroup && /*#__PURE__*/React.createElement(_Box, {
    marginLeft: -2,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: defaultParticipationGroup,
    size: 48,
    variant: "outlined"
  })), coOrganizer && /*#__PURE__*/React.createElement(_Box, {
    marginLeft: -2,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: {
      title: coOrganizer.name,
      photo: coOrganizer.logo
    },
    size: 48,
    variant: "outlined"
  }))), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 600
    },
    variant: "body2"
  }, defaultParticipationGroup === undefined ? /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 200
  }) : t('commons.created_by', {
    creator: sponsorName ? `Geovelo & ${sponsorName}` : 'Geovelo'
  })));
}
export default Sponsors;